// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"styles-module__carouselWrapper___2ajKV","imageWrapper":"styles-module__imageWrapper___3vc4x","img":"styles-module__img___2NlFa"};